'use client';

import Image from '@/components/Image';
import { Routes } from '@/lib/routes/routes';
import { ITrandingStore } from '@/types/cms';
import { PRODUCT_IMAGE_SIZE } from '@/lib/utils/command';
import { Link } from '@/i18n/routing';
import React, { FC, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslations } from 'next-intl';

type TProps = {
  store: ITrandingStore;
  size: number;
};
const TrendingStoresCard: FC<TProps> = ({ store, size }) => {
  const t = useTranslations('stores');

  const [showOverlay, setShowOverlay] = useState(false);

  return (
    <Link href={Routes.branchDetails(store.id)}>
      <motion.div
        className="relative m-2 h-[80px] w-[80px] overflow-hidden rounded-xl md:h-[120px] md:w-[120px] lg:h-[165px] lg:w-[165px]"
        onHoverStart={() => setShowOverlay(true)}
        onHoverEnd={() => setShowOverlay(false)}
        style={{ width: size, height: size }}
      >
        <AnimatePresence>
          {showOverlay && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="bg-primary/20 absolute top-0 left-0 z-10 grid h-full w-full place-items-center"
            >
              <motion.h3
                initial={{ y: 8 }}
                animate={{ y: 0 }}
                exit={{ y: 8 }}
                className="rounded-full bg-white px-2 py-1 text-[10px] font-bold"
              >
                {t('view-store')}
              </motion.h3>
            </motion.div>
          )}
        </AnimatePresence>
        <Image
          src={store.store.logoURL} // Logos are repeated dynamically
          alt={store.name}
          size={PRODUCT_IMAGE_SIZE.MEDIUM}
          fill
          className="object-cover"
          sizes="(min-width: 1080px) 165px, (min-width: 780px) 120px, 80px"
        />
      </motion.div>
    </Link>
  );
};

export default TrendingStoresCard;
